import { CreateOutageViewModel } from "../../../api/generated/models";
import { IFormValues } from "../../../components/form/Form.types";
import {
  ISelectedMarker,
  IStreetlightData,
} from "../../../components/map/Map.types";
import {
  BracketTypeDisplayMap,
  EBracketTypes,
  LampTypeDisplayMap,
} from "../../../shared/enums/utility.enums";
import { isNullOrUndefined } from "../../../shared/utils/data.utils";
import { getGlobalState } from "../../../shared/utils/testing.utils";

export const getMarkerStatusFlag = (key: string | null | undefined): number => {
  if (isNullOrUndefined(key)) {
    throw new Error("key must be defined - getMarkerStatusFlag");
  }
  let reported = 0;
  switch (key) {
    case "Reported":
      reported = 1;
      break;
    case "In Progress":
      reported = 1;
      break;

    default:
      break;
  }

  return reported;
};

export const getBracketTypeDisplayLabel = (key: string): string => {
  let retVal;

  if (key === BracketTypeDisplayMap.COB) {
    key = EBracketTypes.COBRA;
  }

  if (key === BracketTypeDisplayMap.PT) {
    key = EBracketTypes.POST_TOP;
  }

  if (key === BracketTypeDisplayMap.CS) {
    key = EBracketTypes.CENTER_SUSPENSION;
  }

  switch (key) {
    case EBracketTypes.BRACKET:
      retVal = BracketTypeDisplayMap.BKT;
      break;
    case EBracketTypes.COBRA:
      retVal = BracketTypeDisplayMap.COB;
      break;
    case EBracketTypes.CENTER_SUSPENSION:
      retVal = BracketTypeDisplayMap.CS;
      break;
    case EBracketTypes.POST_TOP:
      retVal = BracketTypeDisplayMap.PT;
      break;
    case EBracketTypes.MONGOOSE:
      retVal = BracketTypeDisplayMap.MON;
      break;
    case EBracketTypes.MID_POLE:
      retVal = BracketTypeDisplayMap.MID;
      break;
    case EBracketTypes.SECURITY:
      retVal = BracketTypeDisplayMap.SEC;
      break;
    case EBracketTypes.OTHER:
      retVal = BracketTypeDisplayMap.OTH;
      break;

    default:
      retVal = BracketTypeDisplayMap.UNK;
      break;
  }
  return retVal;
};

export const getLampTypeLabel = (key: string): string => {
  let retVal;
  switch (key) {
    case "HPS":
      retVal = LampTypeDisplayMap.HPS;
      break;
    case "MV":
      retVal = LampTypeDisplayMap.MV;
      break;
    case "MH":
      retVal = LampTypeDisplayMap.MH;
      break;
    case "LED":
      retVal = LampTypeDisplayMap.LED;
      break;
    case "LPS":
      retVal = LampTypeDisplayMap.LPS;
      break;
    case "INC":
      retVal = LampTypeDisplayMap.INC;
      break;
    case "FLUO":
      retVal = LampTypeDisplayMap.FLUO;
      break;

    default:
      retVal = LampTypeDisplayMap.UNK;
      break;
  }

  return retVal;
};

export const getCity = (
  gisCity: string | null,
  geoCity: string | null
): string => {
  let city = "";
  if (!gisCity || /^\s*$/.test(gisCity)) {
    if (geoCity) {
      city = geoCity;
    }
  } else {
    city = gisCity;
  }

  return city;
};

export const buildSubmitPayload = (
  formValues: IFormValues,
  selectedMarker: ISelectedMarker
): CreateOutageViewModel => {
  const { streetLightData, geoLocation } = selectedMarker;
  const { attributes } = streetLightData as IStreetlightData;
  const {
    outageFormName,
    outageFormEmail,
    outageFormPhone,
    outageFormDropdown,
    outageFormBracketType,
    outageFormComments,
  } = formValues;

  const geoLocAddress = geoLocation?.address?.Address || "Address Unknown";
  const geoLocCity = geoLocation?.address?.City;
  const pinModeState = getGlobalState().ui.pinMode;
  const routingState = getGlobalState().ui.routing;

  const { WATTAGE, LATITUDE, LONGITUDE, TRS } = attributes;
  let { LAMPTYPE, FIXTURESUP, CITY, COUNTY, GISID, TOWNSHIP, CONTRACT_A } =
    attributes;

  if (pinModeState.enabled) {
    GISID = null;
    CITY = geoLocCity;
    COUNTY = "";
    TOWNSHIP = "";
    CONTRACT_A = "";
    LAMPTYPE = LampTypeDisplayMap.UNK;
    FIXTURESUP = outageFormBracketType;
  }

  return {
    comments: outageFormComments,
    contacts: [
      {
        name: outageFormName,
        email: outageFormEmail,
        mobilePhone: outageFormPhone.toString(),
      },
    ],
    location: {
      locationId: GISID,
      address: geoLocAddress,
      coordinates: {
        latitude: LATITUDE,
        longitude: LONGITUDE,
      },
      city: getCity(CITY, geoLocCity),
      county: COUNTY,
      township: TOWNSHIP,
      crossStreets: geoLocation?.crossStreets,
      trs: TRS,
      contractAccountNumber: CONTRACT_A,
    },
    outageReason: outageFormDropdown,
    utility: {
      lampType: getLampTypeLabel(LAMPTYPE),
      bracketType: getBracketTypeDisplayLabel(FIXTURESUP),
      wattage: pinModeState.enabled ? null : WATTAGE.toString(),
      type: "Streetlight",
    },
    originator: routingState.originatorFlag
      ? routingState.originatorFlag
      : null,
  };
};
